import { useQuery, useMutation, useQueryClient } from 'react-query';
import {GetProformaInvoiceReport,GetProformaInvoiceSearchDTO,GetProformaInvoiceReportTotal} from '../Api/index';



const useGetProformaInvoiceReport = (body,customizedBody) => {
    let newBody={...body,...customizedBody}
 
    return useQuery(['GetProformaInvoiceReport',newBody],GetProformaInvoiceReport, {
        refetchOnWindowFocus: false,
        enabled:!!newBody,
        onError: () => {
            // console.log('get all damage error')
        }
        ,
        onSuccess: (data) => {
            // console.log('getAllDamageSuccess')
        }
        ,
       select: (data) => {
         let rawData = data?.data;
         return rawData



       }
    })
}

const useGetProformaInvoiceSearchDTO = (body,customizedBody) => {
    let newBody={...body,...customizedBody}
 
    return useQuery(['GetProformaInvoiceSearchDTO',newBody],GetProformaInvoiceSearchDTO, {
        refetchOnWindowFocus: false,
        enabled:true,
        onError: () => {
            // console.log('get all damage error')
        }
        ,
        onSuccess: (data) => {
            // console.log('getAllDamageSuccess')
        }
        ,
       select: (data) => {
         let rawData = data?.data.data;
         return rawData



       }
    })
}

const useGetProformaInvoiceReportTotal = (body,customizedBody) => {
    let newBody={...body,...customizedBody}
 
    return useQuery(['GetProformaInvoiceReportTotal',newBody],GetProformaInvoiceReportTotal, {
        refetchOnWindowFocus: false,
        enabled:!!newBody,
        onError: () => {
            // console.log('get all damage error')
        }
        ,
        onSuccess: (data) => {
            // console.log('getAllDamageSuccess')
        }
        ,
       select: (data) => {
         let rawData = data?.data?.data;
         return rawData
       }
    })
}

export {
    useGetProformaInvoiceReport,
    useGetProformaInvoiceSearchDTO,
    useGetProformaInvoiceReportTotal
}